/**
 * The crypto payment screen in a pop-up, for paying from the dashboard without leaving it. On a phone
 * it is a sheet from the bottom. Closing it leaves the payment open; the card offers to show it again.
 */
import type { CryptoPayment } from '@platform/shared';
import { PaymentPanel } from './NowPaymentsDeposit';
import { Sheet } from './Sheet';

export function PayDialog({ p, onClose, onReset }: { p: CryptoPayment; onClose: () => void; onReset: () => void }) {
  return (
    <Sheet title="Deposit with crypto" onClose={onClose}>
      <PaymentPanel p={p} onReset={onReset} className="mt-6" />
    </Sheet>
  );
}
